const config = {
    APP_NAME: 'Trendico Intranet',
    TITLE_NAME: ' - Trendico NET'
};

export default config;